import React from 'react';
import Navbar from './Navbar';
import BannerBackground from '../assets/home-banner-background.png';
import BannerImage from "../assets/home-banner-image.png";
import { FiArrowRight } from "react-icons/fi";

const Home = () => {
  return (
    <div className='home-container'>
      <Navbar />
      <div className='home-banner-container'>
        <div className='home-bannerImage-container'>
            <img src={BannerBackground} alt="Banner Background" />
        </div>
        <div className='home-text-section'>
            <h1>
                Crave More. Wait Less.
            </h1>
            <p className='primary-text'>
                Discover the food you love from the best restaurants near you. Fast delivery, 
                fresh meals, and unforgettable taste
            </p>
            <button className='secondary-button'>
                Order Now <FiArrowRight />
            </button>
        </div>

        <div className='home-image-container'>
            <img src={BannerImage} alt="Banner Hero Image"/>
        </div>
      </div>
    </div>
  )
}

export default Home
